import "./src/styles/global.css"

import React from 'react';
import {DarkModeProvider} from './src/hooks/dark-mode-context';
import {AuthProvider} from "./src/hooks/authContext";

export const wrapPageElement = ({element}) => (
    <DarkModeProvider>
        <AuthProvider>
            {element}
        </AuthProvider>
    </DarkModeProvider>
);
